import apiClient from './client';
import { User } from '../types';

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  token: string;
  refreshToken: string;
  user: User;
}

export const authApi = {
  login: (data: LoginRequest) =>
    apiClient.post<LoginResponse>('/v1/auth/login', data).then((r) => r.data),

  refresh: (refreshToken: string) =>
    apiClient.post<{ token: string }>('/v1/auth/refresh', { refreshToken }).then((r) => r.data),

  me: () => apiClient.get<User>('/v1/auth/me').then((r) => r.data),
};
